export default __webpack_public_path__ + "static/media/winner.a1d2383a.gif";